exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar-content[data-v-b73ae1d4]{padding:1rem;height:100%;overflow-y:auto}.form-section[data-v-b73ae1d4]{margin-bottom:2rem;padding-bottom:1rem;border-bottom:1px solid #eee}.form-section[data-v-b73ae1d4]:last-child{border-bottom:none}.section-title[data-v-b73ae1d4]{color:#495057;font-weight:600;margin-bottom:1rem;padding-bottom:.5rem;border-bottom:2px solid #0d6348}.form-actions-bottom[data-v-b73ae1d4]{position:absolute;width:100%;padding:20px 25px;left:0;bottom:0;background:#fff;border-top:1px solid #eee;text-align:right}", ""]);

// exports
